/**
 * Set up in window environment variable
 * WARNING: key and process.env.key_name should be the same
 * like this initEnvValue('NODE_ENV', process.env.NODE_ENV);
 * to find a error if key doesn't exist
 * because not work such process.env[key]
 */
export function initEnvValue(key, value, withValidation = true) {
  if (withValidation && value === undefined) throw new Error(`A env key "${key}" is required. Please and to .env file`);
  window[key] = value;
}
